import { useHistory, useLocation } from 'react-router-dom';
import { HashFlag } from '../routes/hashFlags.const';

interface UseHashFlagResult {
  isOpen: boolean;
  value?: string;
  open: (value?: string) => void;
  close: () => void;
}

const decodeValue = (value: string) => {
  try {
    return decodeURIComponent(value);
  } catch {
    return undefined;
  }
};

const parseHash = (hash: string) => {
  const [flag, value] = hash.replace('#', '').split('=');

  return { flag, value: value ? decodeValue(value) : undefined };
};

const useHashFlag = (flag: HashFlag): UseHashFlagResult => {
  const { pathname, search, hash } = useLocation();
  const history = useHistory();

  const current = parseHash(hash);
  const isOpen = current.flag === flag;

  const open = (value?: string) => {
    const fragment = value ? `${flag}=${encodeURIComponent(value)}` : flag;
    const url = `${pathname}${search}#${fragment}`;

    if (isOpen) {
      history.replace(url);
      return;
    }

    history.push(url);
  };

  return {
    isOpen,
    value: isOpen ? current.value : undefined,
    open,
    close: () => history.push(`${pathname}${search}`),
  };
};

export default useHashFlag;
